// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.3_webpack@5.105.2/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.3_webpack@5.105.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XblKPXobhlNhiz {
  box-sizing: border-box;
}

.SU1DZeXztHn0OI {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.SU1DZeXztHn0OI::-webkit-scrollbar {
  display: none;
}

.zvDaLUEy7ws2S9 {
  resize: none;
}

.KuhZdUWJ1Y97F8 {
  line-height: 1.5;
}

.n6xceCXyzoNoG7 {
  margin-top: var(--ds-space-100, 8px);
  text-align: right;
  font-size: 12px;
  line-height: 16px;
}

.n6xceCXyzoNoG7 b {
  font-weight: var(--ds-font-weight-semibold, 600);
}
`, ""]);
// Exports
export var root = `XblKPXobhlNhiz`;
export var hideScrollbar = `SU1DZeXztHn0OI`;
export var hideResizeHandle = `zvDaLUEy7ws2S9`;
export var verticalCenter = `KuhZdUWJ1Y97F8`;
export var newlineHint = `n6xceCXyzoNoG7`;
export default ___CSS_LOADER_EXPORT___;
